import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classes from "./HomePage.module.css";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { FaCircleInfo } from "react-icons/fa6";

function HomePage() {
    return (
        <main>
            <section id='topo' className={classes.topoSite}>
                <div className="interface">
                    <div className={`flex ${classes.parte}`}>
                        <div className={classes.txtTopoSite}>
                            <h1 className="titulo">DESVENDANDO A TERRA<br /><span>COM TECNOLOGIA E PRECISÃO.</span></h1><br />
                            <h1 className={classes.subtitulo}>Dados, tecnologia e inteligência para decisões estratégicas</h1>
                            <p>
                                A TerraData é uma empresa de tecnologia e dados especializada em transformar informações em conhecimento estratégico. Atuamos desde a coleta até a análise, oferecendo soluções completas para organizações que precisam entender melhor seus territórios, mercados e operações.<br /><br />
                                Combinamos tecnologia, pesquisa e inteligência analítica para entregar dados confiáveis, organizados e prontos para apoiar a tomada de decisão.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <br />
            <section id='servicos' className={classes.especialidades}>
                <div className="interface">
                    <h2 className="titulo">NOSSAS <span>SOLUÇÕES.</span></h2><br />

                    <div className={`container-fluid ${classes.container}`}>
                        {/* row-cols-1: 1 coluna no mobile | row-cols-md-3: 3 colunas no desktop | g-4: espaçamento lateral e vertical */}
                        <div className={`row row-cols-1 row-cols-md-3 g-4 ${classes.flex}`}>

                            {/* Card 1 */}
                            <div className="col">
                                <div className="card h-100 p-3 shadow-sm">
                                    <div className="card-body">
                                        <h4 className="card-title">💻 Software</h4>
                                        <ul className="card-text">
                                            <li>Aplicativos de coleta</li>
                                            <li>Websites personalizados</li>
                                            <li>Web crawlers (coletores de sites)</li>
                                            <li>Painéis gráficos interativos</li>
                                            <li>Integrações via API</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Card 2 */}
                            <div className="col">
                                <div className="card h-100 p-3 shadow-sm">
                                    <div className="card-body">
                                        <h4 className="card-title">🧠 Pesquisa</h4>
                                        <ul className="card-text">
                                            <li>Pesquisa de mercado</li>
                                            <li>Pesquisa de opinião pública</li>
                                            <li>Pesquisa de satisfação</li>
                                            <li>Formulários de Entrevista</li>
                                            <li>Segmentação de público</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Card 3 */}                            
                            <div className="col">
                                <div className="card h-100 p-3 shadow-sm">
                                    <div className="card-body">
                                        <h4 className="card-title">📊 Coleta de Dados<br /></h4>
                                        <ul className="card-text">
                                            <li>Pesquisas presenciais e remotas (em campo e online)</li>
                                            <li>Aplicação de questionários</li>
                                            <li>Coleta georreferenciada</li>
                                            <li>Auditorias em campo e online</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>


                            {/* Card 4 */}
                            <div className="col">
                                <div className="card h-100 p-3 shadow-sm">
                                    <div className="card-body">
                                        <h4 className="card-title">📈 Tratamento e Análise de Dados</h4>
                                        <ul className="card-text">
                                            <li>Limpeza e padronização</li>
                                            <li>Cruzamento de bases</li>
                                            <li>Modelagem estatística</li>
                                            <li>Relatórios analíticos</li>
                                            <li>Construção de pipeline de dados ETL</li>
                                            <li>Análise Preditiva e Prescritiva</li>                                            
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Card 5 */}
                            <div className="col">
                                <div className="card h-100 p-3 shadow-sm">
                                    <div className="card-body">
                                        <h4 className="card-title">🗺️ Inteligência Territorial</h4>
                                        <ul className="card-text">
                                            <li>Mapas interativos</li>
                                            <li>Análise geoespacial</li>
                                            <li>Diagnósticos regionais</li>
                                            <li>Apoio a projetos</li>
                                            <li>Modelagem Preditiva</li>
                                            <li>Simulação e Análise de Cenários</li>
                                            <li>Relatórios Georreferenciados</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Card 5 */}
                            <div className="col">
                                <div className="card h-100 p-3 shadow-sm">
                                    <div className="card-body">
                                        <h4 className="card-title">🤖 Automação com Inteligência Artificial</h4>
                                        <ul className="card-text">
                                            <li>Atendimento automatizado via WhatsApp</li>
                                            <li>Notificações inteligentes (e-mail, WhatsApp, etc.)</li>
                                            <li>Automação de fluxos de trabalho</li>
                                            <li>Robôs para tarefas repetitivas</li>
                                            <li>Integração entre sistemas</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Card 5 */}


                            {/* Card 6 */}
                            {/* <div className="col">
                            <div className="card h-100 p-3 shadow-sm">
                                <div className="card-body">
                                    <h4 className="card-title">☁️ Infraestrutura e Hospedagem</h4>
                                    <ul className="card-text">
                                        <li>Hospedagem de sistemas</li>
                                        <li>Banco de dados</li>
                                        <li>Ambientes seguros</li>
                                        <li>Alta disponibilidade</li>
                                    </ul>
                                </div>
                            </div>
                        </div> */}

                            <div className={`btnContato ${classes.btnContato}`}>
                                <a href='/servicos'><button><FontAwesomeIcon icon={faCircleInfo} />&nbsp;&nbsp;Saiba mais</button></a>
                            </div>

                        </div>
                    </div>
                </div>

            </section>
            <br /><br />
        </main>
    );
}

export default HomePage;